import { render, staticRenderFns } from "./PrepareTranslate.vue?vue&type=template&id=1570e3a6"
import script from "./PrepareTranslate.vue?vue&type=script&lang=js"
export * from "./PrepareTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports